<template>
    <component :is="entry.component" v-bind="entry.props" @close="$emit('close')" v-on="entryEmits">
        <template :key="`entry-slot-${key}`" v-for="(slot, key) in entry.slots" #[key]>
            <div v-html="slot" v-if="typeof slot === 'string'" />
            <component
                :is="slot.component"
                :key="`entry-slot-options-${key}`"
                v-bind="slot.props"
                v-on="slot.emits"
                v-else-if="isModalSlotOptions(slot)"
            />
            <component :is="slot" :key="`entry-slot-cmp-${key}`" v-else />
        </template>
    </component>
</template>

<script setup lang="ts">
    /**
     * Renders the caller-provided dynamic component with its props, slots, and
     * event handlers so modal and drawer panels stay presentation-only.
     */
    import { computed } from 'vue';
    import { type ModalData } from '@/store/modules/dynamicModals/store.ts';
    import { isModalSlotOptions } from '@/store/modules/dynamicModals/types.ts';
    import { provideDynamicModalOwner } from '@/store/hooks/dynamicModalOwner.ts';

    type Emits = (e: 'close') => void;

    const props = defineProps<{
        entry: ModalData;
    }>();

    if (props.entry.owner) {
        provideDynamicModalOwner(props.entry.owner);
    }

    defineEmits<Emits>();

    const entryEmits = computed(() => {
        if (!props.entry.emits) {
            return {};
        }

        const otherEmits = { ...props.entry.emits };
        delete otherEmits.close;
        return otherEmits;
    });
</script>
